import { fetchGet } from "..";
import { NavParamsObject } from "../../components/Promotion/Utils";
import { Meta } from "../../types/responses/APIResponse";

type APIResponse<T> = {
  meta: Meta;
} & T;

export type Nav = {
  title: string;
  route: string;
  params: NavParamsObject;
};

type Link = {
  title: string;
  url: string;
};

export const getExternalWebsitesNavigation = async (): Promise<Nav[]> => {
  const { external_links } = (await fetchGet("external-links")) as APIResponse<{
    external_links: Link[];
  }>;
  if (external_links?.length)
    return external_links.map((link) => ({
      title: link.title,
      route: link.url,
      params: {},
    }));
  return [];
};
